import { del, get, post, put } from 'lib/actionHelpers.js';

export const getLead = (leadId, callback) => {
  return get(`/lead/${leadId}`, {
    action: 'GET_LEAD',
    callback,
  });
};

export const getEventThread = ({ threadId, serviceProviderId }, callback) => {
  return get(`/event/get-thread-events/${threadId}?service_provider_id=${serviceProviderId}`, {
    action: 'GET_EVENT_THREAD',
    callback,
  });
};

export const getPipelineLead = (pipelineLeadId, callback) => {
  return get(`/pipeline-lead/${pipelineLeadId}`, {
    action: 'GET_PIPELINE_LEAD',
    callback,
  });
};

export const patchPipelineLeadStatus = (pipelineLead, status, callback) => () => {
  const { id, pipeline_id, service_provider_id, lead_id, stage_id, service_person_id } = pipelineLead;
  return post(`/pipeline-lead/${id}/update`, {
    data: {
      status_id: status.id,
      sub_status_id: status.sub_status_id,
      pipeline_id,
      service_provider_id,
      stage_id,
      set_new_user: '0',
      lead_id,
      service_location_id: status.service_location_id,
      service_person_id,
    },
    action: 'PATCH_PIPELINE_LEAD_STATUS',
    callback,
  });
};

const pipelineLeadMap = {
  pipelineLeadId: 'id',
  id: 'id',
  leadId: 'lead_id',
  lead_id: 'lead_id',
  note: 'note',
  pipelineId: 'pipeline_id',
  pipeline_id: 'pipeline_id',
  serviceProviderId: 'service_provider_id',
  service_provider_id: 'service_provider_id',
  serviceLocationId: 'service_location_id',
  service_location_id: 'service_location_id',
  servicePersonId: 'service_person_id',
  service_person_id: 'service_person_id',
  stageId: 'stage_id',
  stage_id: 'stage_id',
  statusDate: 'status_date',
  status_date: 'status_date',
  statusId: 'status_id',
  status_id: 'status_id',
  subStatusId: 'sub_status_id',
  sub_status_id: 'sub_status_id',
  contactId: 'contact_id',
  contact_id: 'contact_id',
};

export const putPipelineLead = (state) => {
  let mapKeys = Object.keys(pipelineLeadMap);
  let payload = {
    set_new_user: state.userId ? '1' : '0',
    new_user_id: state.userId,
  };
  for (let i = 0; i < mapKeys.length; i++) {
    if (state[mapKeys[i]]) {
      payload[pipelineLeadMap[mapKeys[i]]] = state[mapKeys[i]];
    }
  }
  return post(`/pipeline-lead/${state.pipelineLeadId}/update`, {
    data: payload,
    action: 'PATCH_PIPELINE_LEAD_STATUS',
    callback: state.callback,
  });
};

export const postLeadCall = (leadId, serviceProviderId, number, callback) => {
  return post(`/lead/${leadId}/call`, {
    data: {
      number,
      service_provider_id: serviceProviderId,
    },
    action: 'POST_PHONE_CALL',
    callback,
  });
};

export const postLead = (data, callback) => {
  return put(`/lead/create`, {
    data,
    action: 'POST_LEAD',
    callback,
  });
};

export const postNote = (leadId, serviceProviderId, note, callback) => {
  return post(`/lead/${leadId}/add-note`, {
    data: {
      service_provider_id: serviceProviderId,
      note,
    },
    action: 'POST_COMPOSER_MESSAGE',
    callback,
  });
};

export const putNote = (noteId, leadId, params, callback) => {
  return post(`/lead/${leadId}/note/${noteId}/update`, {
    data: { ...params },
    action: 'PUT_NOTE',
    callback,
  });
};

export const putLeadBusinessName = (lead_id, data, callback, isDelete = false) => {
  const method = isDelete === true ? del : post;
  return method(`/lead/${lead_id}/update`, {
    data,
    action: 'PUT_LEAD_BUSINESS_NAME',
    callback,
  });
};

export const putServiceInterest = (pipelineLeadId, data, actionType, callback) => {
  const actionTypeMap = {
    add: {
      method: put,
      url: `/pipeline-lead/${pipelineLeadId}/add-service-interest`,
    },
    edit: {
      method: post,
      url: `/pipeline-lead/${pipelineLeadId}/update-service-interest`,
    },
    delete: {
      method: del,
      url: `/pipeline-lead/${pipelineLeadId}/delete-service-interest`,
    },
  };
  const url = (actionTypeMap[actionType] || {}).url;
  const method = (actionTypeMap[actionType] || {}).method;
  return method(url, {
    data,
    action: 'PUT_SERVICE_INTEREST',
    callback,
  });
};

export const getPipelineLeads = (pipeline_id, callback, actionName = undefined) => {
  return get(`/pipeline/${pipeline_id}/pipeline-leads`, {
    action: actionName || 'GET_PIPELINE_LEADS',
    callback,
  });
};

export const postEmail = (data, callback) => {
  return post(`/lead/${data.leadId}/email`, {
    data: {
      contact_detail_id: data.contactDetailId,
      contact_id: data.contactId,
      service_provider_id: data.serviceProviderId,
      platform_registration_id: data.platformRegistrationId,
      subject: data.subject,
      message: data.messageHtml,
      file_ids: data.fileIds,
      ccs: data.ccs,
      bccs: data.bccs,
      reply_to_message_id: data.replyToMessageId,
      save: data.save === 1 ? 1 : 0,
      email_id: data.email_id,
      service_location_id: data.serviceLocationId,
    },
    action: 'POST_COMPOSER_MESSAGE',
    callback,
  });
};

export const postDraftEmail = (data, callback) => () => {
  return post(`/lead/${data.leadId}/email`, {
    data: {
      contact_detail_id: data.contactDetailId,
      contact_id: data.contactId,
      service_provider_id: data.serviceProviderId,
      platform_registration_id: data.platformRegistrationId,
      subject: data.subject,
      message: data.messageHtml,
      file_ids: data.fileIds,
      ccs: data.ccs,
      bccs: data.bccs,
      reply_to_message_id: data.replyToMessageId,
      save: data.save === 1 ? 1 : 0,
      email_id: data.email_id,
    },
    action: 'POST_DRAFT_EMAIL',
    callback,
  });
};

export const postTodo = (data, callback) => {
  return put(`/todo/create`, {
    data,
    action: 'POST_COMPOSER_MESSAGE',
    callback,
  });
};

const patchTodoMap = {
  statusId: 'status_id',
  status_id: 'status_id',
  serviceLocationId: 'service_location_id',
  leadId: 'lead_id',
  targetDatetime: 'target_datetime',
  description: 'description',
  typeId: 'type_id',
  pipelineLeadId: 'pipeline_lead_id',
  assigneeUserId: 'assignee_user_id',
};
export const patchTodo = (data) => {
  let mapKeys = Object.keys(patchTodoMap);
  let dataKeys = Object.keys(data);
  let payload = {};
  for (let i = 0; i < mapKeys.length; i++) {
    if (dataKeys.includes(mapKeys[i])) {
      payload[patchTodoMap[mapKeys[i]]] = data[mapKeys[i]];
    }
  }
  return post(`/service-provider/provider/${data.serviceProviderId}/todo/${data.id}/update`, {
    data: payload,
    action: 'PATCH_TODO',
    callback: data.callback,
  });
};

export const putContact = (contact, data, callback) => {
  return post(`/lead/${contact.lead_id}/contact/${contact.contact_id}/update`, {
    data,
    action: 'POST_CONTACT_OR_CONTACT_DETAIL',
    callback,
  });
};

export const putContactDetail = (leadId, contactId, data, callback) => {
  return post(`/lead/${leadId}/contact/${contactId}/detail/${data.id}/update`, {
    data,
    action: 'POST_CONTACT_OR_CONTACT_DETAIL',
    callback,
  });
};

export const postContactDetail = (leadId, contactId, data, callback) => {
  return put(`/lead/${leadId}/contact/${contactId}/add-detail`, {
    data,
    action: 'POST_CONTACT_OR_CONTACT_DETAIL',
    callback,
  });
};

export const postContact = (leadId, data, callback) => {
  return put(`/lead/${leadId}/add-contact`, {
    data,
    action: 'POST_CONTACT_OR_CONTACT_DETAIL',
    callback,
  });
};

export const deleteContactDetail = ({ leadId, contactId, detailId, serviceProviderId, deleted }, callback) => {
  return post(`/lead/${leadId}/contact/${contactId}/detail/${detailId}/update`, {
    data: {
      deleted: deleted,
      service_provider_id: serviceProviderId,
    },
    action: 'POST_CONTACT_OR_CONTACT_DETAIL',
    callback,
  });
};
